import { useCallback, useState } from "react";
import { getAuthenticatedAxios } from "./authentication";

export interface HelpSearchData {
  id: string;
  displayName: string;
  imageUrl: string;
  searchTextRelated: string;
  categoryId: string;
  categoryName: string;
}

export interface HelpSearchResult {
  data: HelpSearchData[];
}

export function useHelpSearch(isInternal: boolean) {
  const { axios } = getAuthenticatedAxios();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>();

  const search = useCallback(
    async (text: string, language: string): Promise<HelpSearchData[]> => {
      setIsLoading(true);
      setError(undefined);

      try {
        const params = new URLSearchParams();
        params.set("text", text);
        params.set("language", language);

        const url = isInternal
          ? "/v0/content/help-internal/search"
          : "/v0/content/help-external/search";

        const response = await axios.get(url, { params });
        return response.data;
      } catch (err) {
        const error = err as Error;
        setError(error);
        throw error;
      } finally {
        setIsLoading(false);
      }
    },
    [axios, isInternal],
  );

  const clearResults = () => {
    setError(undefined);
  };

  return { search, isLoading, error, clearResults };
}
